import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import getClsWithPrefix from '../cls';
import './index.less';

const subPrefix = 'CommonModal';
const cls$ = getClsWithPrefix(subPrefix);

export interface CommonModalProps {
    open?: boolean;
    className?: string;
    wrapClassName?: string;
    wrapProps?: Partial<
        React.HTMLProps<HTMLDivElement> & {
            [k in `data-${string}`]?: string | boolean;
        }
    >;
    style?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
    /** 存在于mask上，且不在Modal内部的元素 */
    metaNode?: React.ReactNode;
    children: React.ReactNode;
    zIndex?: number;
    maskClosable?: boolean;
    destroyOnClose?: boolean;
    onClose?: () => void;
    lockScroll?: boolean;
}

const CommonModal: React.FC<CommonModalProps> = ({
    open = false,
    className = '',
    wrapClassName = '',
    wrapProps,
    metaNode,
    children,
    zIndex = 999,
    maskClosable = false,
    destroyOnClose = false,
    onClose,
    lockScroll = true,
}) => {
    useEffect(() => {
        if (open && lockScroll) {
            disableBodyScroll(document.body, {
                reserveScrollBarGap: true,
            });
            return () => {
                enableBodyScroll(document.body);
            };
        }
    }, [open, lockScroll]);

    if (!open && destroyOnClose) return null;

    return createPortal(
        <div
            {...wrapProps}
            className={classNames(cls$(), wrapClassName)}
            style={{
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                '--zindex': zIndex,
                display: open ? undefined : 'none',
                ...wrapProps?.style,
            }}
        >
            <div
                className={cls$('mask')}
                onClick={(e) => {
                    // 阻止蒙层点击透传到后面的dom
                    e.stopPropagation();
                    e.preventDefault();
                    if (maskClosable) onClose?.();
                }}
            ></div>
            <div className={classNames(cls$('inner'), className)}>{children}</div>
            {metaNode}
        </div>,
        document.body,
    );
};

export default CommonModal;
